export enum ContractCommentsStatus {
    COMMENTED_BY_WORKER = 'COMMENTED_BY_WORKER',
    COMMENTS_REJECTED_BY_KO = 'COMMENTS_REJECTED_BY_KO',
    COMMENTS_ACCEPTED_BY_KO = 'COMMENTS_ACCEPTED_BY_KO',
}